import { merchantsApi } from './authenticatedApi'
import {
  Address,
  MerchantResponse,
  CreateMerchantRequest,
  UpdateMerchantRequest,
  PagedMerchantResponse,
} from './generated/models'

// Re-export types for backward compatibility
export type Merchant = MerchantResponse
export type { Address, CreateMerchantRequest, UpdateMerchantRequest }

export interface MerchantListResponse {
  items: Merchant[]
  totalCount: number
  page: number
  size: number
}

export const getMerchants = async (page = 0, size = 10): Promise<MerchantListResponse> => {
  const response = await merchantsApi.listMerchantsV1(page, size)
  const data = response.data as any
  return {
    items: data.items || [],
    totalCount: data.total || 0,
    page: data.page || page,
    size: data.pageSize || size,
  }
}

export const getMerchantById = async (id: string): Promise<Merchant> => {
  const response = await merchantsApi.getMerchantV1(id)
  return response.data
}

export const createMerchant = async (data: CreateMerchantRequest): Promise<Merchant> => {
  const response = await merchantsApi.createMerchantV1(data)
  return response.data
}

export const updateMerchant = async (id: string, data: UpdateMerchantRequest): Promise<Merchant> => {
  const response = await merchantsApi.updateMerchantV1(id, data)
  return response.data
}
